module.exports = {
  "id": "6c2d8ff4-a154-426b-96d2-614871d42e5b",
  "gtmIds": [
    "GTM-52BC25",
    " GTM-NT8FH75"
  ],
  "startTracking": "since_launch",
  "hasInAppVersion": true,
  "group": "skibig3",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://www.skibig3.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}